import React from "react";

const FeatureItem = ({ children }) => (
  <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#02aee6] hover:scale-105 duration-150 hover:shadow-lg ">
    <p className="mb-0 text-xl text-[#192027] font-semibold hover:text-[#02aee6]">
      {children}
    </p>
  </div>
);

const AllFeatures = () => {
  return (
    <div className="relative flex flex-col justify-center items-center sm:px-0 px-3 sm:pb-0 pb-12 mt-10">
      <div className="text-center">
        <p className="text-5xl text-black font-bold">
          Accounting Software to{" "}
          <span
            className=""
            style={{
              backgroundImage:
                "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            Simplify Businesses
          </span>
        </p>
        <p className="text-2xl italic mt-1">
          GST compliant Fully Accounting Software
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 items-center gap-x-3 bg-[#e6f7ff] rounded-lg shadow-md py-3 sm:py-10 px-2 sm:px-10 w-full mt-5 max-w-7xl">
        <div className="space-y-3">
          <FeatureItem>Sales Management</FeatureItem>
          <FeatureItem>Purchase Management</FeatureItem>
          <FeatureItem>TDS Management</FeatureItem>
          <FeatureItem>Inventory Management</FeatureItem>
          <FeatureItem>Bank Management</FeatureItem>
          <FeatureItem>Cash Management</FeatureItem>
          <FeatureItem>Job Work Management</FeatureItem>
          <FeatureItem>Goods Consumption Management </FeatureItem>
          <FeatureItem>Tour/ Agency Management</FeatureItem>
        </div>
        <div className="space-y-3 mt-3 sm:mt-0">
          <FeatureItem>E-Invoice</FeatureItem>
          <FeatureItem>Annual Financial Statements</FeatureItem>
          <FeatureItem>Online data collection (AIS/TIS/26AS)</FeatureItem>
          <FeatureItem>Comprehensive Dashboard</FeatureItem>
          <FeatureItem>Commission & Interest calculation</FeatureItem>
          <FeatureItem>Special Modules for Businesses</FeatureItem>
          <FeatureItem>Depreciation Tool</FeatureItem>
          <FeatureItem>Secure Data Entry</FeatureItem>
          <FeatureItem>Technical Support</FeatureItem>
        </div>
        <div className="space-y-3 mt-3 sm:mt-0">
          <FeatureItem>E-way Bill</FeatureItem>
          <FeatureItem>GSTR-1 /3B /4 /ITC-04/ 9 /CMP-08</FeatureItem>
          <FeatureItem>GSTR 2A Excel import</FeatureItem>
          <FeatureItem>Data Import/Export</FeatureItem>
          <FeatureItem>Quotation /Order form Generation</FeatureItem>
          <FeatureItem>Cheque /Envelop print</FeatureItem>
          <FeatureItem>Email / SMS Facility</FeatureItem>
          <FeatureItem>Analysis Reports</FeatureItem>
          <FeatureItem>Suggestion & Query system</FeatureItem>
        </div>
      </div>
      <div className="w-full flex justify-end mt-2 mb-7 max-w-7xl">
        <a
          href="https://www.easyofficesoftware.com/easyacc"
          target="_blank"
          rel="noreferrer"
          className="flex items-center justify-end"
        >
          <p className="mb-0 mr-1 text-black text-lg font-bold">Learn More</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default AllFeatures;
